var React = require('react');

function DiamondInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28 14L14 28 0 14 14 0z"}));
}

DiamondInline.defaultProps = {"viewBox":"0 0 28 28","fill":"#A94A7D"};

module.exports = DiamondInline;

DiamondInline.default = DiamondInline;
